import { CSSProperties, ReactNode } from "react";
import { IObject, IResponse } from "../constants/interface";

export interface RuleProps {
  prefix?: string;
  label?: string;
  value?: string;
}

export interface AutoMatchProps extends AutoMatchDropdownBaseProps {
  /** 指定当前选中的条目 */
  value?: string[];
  /** 自定义类名 */
  className?: string;
  /** 选择框默认文本 */
  placeholder?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 是否显示下拉小箭头 */
  showArrow?: boolean;
  /** 匹配规则参数 */
  defaultParams?: IObject;
  /** 支持清除 */
  allowClear?: boolean;
  /** 禁用 */
  disabled?: boolean;
  /** 自定义节点 label、prefix、value 的字段 */
  fieldNames?: RulesfieldNamesType;
  /** 下拉菜单和选择器同宽。默认将设置 min-width，当值小于选择框宽度时会被忽略 */
  dropdownMatchSelectWidth?: number;
  /** 远程获取匹配规则 */
  fetchApi?: (params?: IObject) => Promise<IResponse>;
  /** 数据处理 */
  onBeforeData?: (data: any) => RuleProps[];
  /** 选中 option，或 input 的 value 变化时，调用此函数 */
  onChange?: (value?: string[]) => void;
  /** 失去焦点时回调 */
  onBlur?: () => void;
  /** 获得焦点时回调 */
  onFocus?: () => void;
};

export interface AutoMatchDropdownBaseProps {
  /** 加载中状态 */
  loading?: boolean;
  /** 匹配规则 */
  rules?: RuleProps[];
  /** 下拉菜单样式 */
  dropdownStyle?: CSSProperties;
  /** 下拉菜单的 className 属性 */
  popupClassName?: string;
  /** dropdown高度 */
  listHeight?: number;
  /** 值为空时提示 */
  valueEmprtTip?: ReactNode;
  /** 匹配规则为空时提示 */
  ruleEmprtTip?: ReactNode;
  /** 菜单渲染父节点。默认渲染到 body 上 */
  getPopupContainer?: () => HTMLElement | HTMLElement;
}

export type RulesfieldNamesType = Partial<IRulesfieldNames>;

export interface IRulesfieldNames {
  /** 标题 */
  label: string;
  /** 值 */
  value: string;
  /** 匹配规则 */
  prefix: string;
}

/** RulesfieldNames默认值 */
export const DEFAULT_RULES_FIELD_NAMES: IRulesfieldNames = {
  label: 'label',
  value: 'value',
  prefix: 'prefix',
};

export interface AutoMatchOption {
  /** 标题 */
  label: string;
  /** 值 */
  value: string;
}
